import { combineReducers } from 'redux';
import assets from './asset.reducer';

const assetAppReducer = combineReducers({
    assets,
});

export default assetAppReducer;



// WEBPACK FOOTER //
// src/main/content/asset/store/reducers/index.js